import React from "react";
import styles from "./Authentication.module.scss";

export default function Authentication() {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <img src="/process.svg" alt="Processing" className={styles.image} />
        <h1 className={styles.heading}>Authentication Complete</h1>
        <p className={styles.subtext}>
          You will be redirected to your application
        </p>
      </div>
    </div>
  );
}

export const AuthenticationExpiry = () => {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <img src="/process.svg" alt="Processing" className={styles.image} />
        <h1 className={styles.heading}>Logged out</h1>
        <p className={styles.subtext}>You will be redirected to login</p>
      </div>
    </div>
  );
};
